import { HierarchyContextProps, IHierarchyActionRemoveSingleReplacement } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Removes a single replacement from the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The remove-single-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_removeSingleReplacement = (
  state: HierarchyContextProps,
  action: IHierarchyActionRemoveSingleReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const ix = state.hierarchy.singles.findIndex((s) => s.airid === action.single.airid);
  if (ix > -1) {
    return hcr_updateChangedFlag(
      {
        ...state,
        hierarchy: {
          ...state.hierarchy,
          singles: state.hierarchy.singles.filter((s) => s.airid !== action.single.airid),
        },
      },
      action,
    );
  }

  return state;
};
